import { useTranslation } from "react-i18next";

interface ConditionBadgeProps {
  condition: string;
}

const CONDITION_STYLES: Record<string, string> = {
  new: "bg-emerald-100 text-emerald-800",
  like_new: "bg-green-100 text-green-800",
  good: "bg-slate-100 text-slate-700",
  acceptable: "bg-amber-100 text-amber-800",
};

export function ConditionBadge({ condition }: ConditionBadgeProps) {
  const { t } = useTranslation();
  const style = CONDITION_STYLES[condition] || "bg-gray-100 text-gray-800";
  const label = t(`conditions.${condition}`, condition);

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${style}`}
    >
      {label}
    </span>
  );
}
